import "./App.css";
import Search from "./Search/Search";

function App() {
  return (
    <div className="App">
      <div className="container">
        <Search />
        <p className="code">
          <a href="https://github.com/ninapruchai/weather-react-app">
            Open-source code
          </a>
        </p>
      </div>
    </div>
  );
}

export default App;
